import * as angular from 'angular';
import { reactShell } from 'angular/utils/config';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ConditionsPlatformSettingsCtrl',
            ConditionsPlatformSettingsCtrl
        );

    function ConditionsPlatformSettingsCtrl(
        $log,
        $http,
        $window,
        $rootScope,
        API_URL,
        DATES,
        platformSettingsService,
        TradeCondition
    ) {
        var vm = this;

        var URL = API_URL.SHIPPERS + '/tradingConditions';
        vm.DATES = DATES;
        vm.NEW_TRADING_CONDITION =
            platformSettingsService.NEW_TRADING_CONDITION;

        vm.conditionList = [];
        vm.addNewTradingCondition = false;
        vm.newCondition = {};
        vm.savingFailed = false;
        vm.conditionToDelete = null;

        vm.addConditionSuccessEvent =
            platformSettingsService.BROADCAST.ADDED_CONDITION;

        vm.cancelNewCondition = cancelNewCondition;
        vm.submitNewCondition = submitNewCondition;
        vm.remove = remove;
        vm.download = download;

        //for Ordering
        vm.predicate = 'name';
        vm.reverse = false;
        // initilize popover feature for this page
        $('[data-toggle="popover"]').popover();
        vm.popoverDocuments = {
            templateUrl: require('app/_directives/popoverDocumentsTemplate.html'),
            content: []
        };

        fetchConditions();

        function fetchConditions() {
            TradeCondition.query(
                { dontCache: new Date().getTime() },
                function (res) {
                    vm.conditionList.splice(0, vm.conditionList.length);
                    vm.conditionList.push.apply(vm.conditionList, res);
                }
            );
        }

        function cancelNewCondition() {
            vm.addNewTradingCondition = false;
        }

        function submitNewCondition(isValid) {
            if (!isValid) {
                return;
            }
            save(vm.newCondition);
        }

        function remove() {
            TradeCondition.delete({ id: vm.conditionToDelete.id }, function () {
                fetchConditions();
                /*
                 for (var i = 0; i < vm.conditionList.length; i++) {
                 if (vm.conditionList[i].name === vm.conditionToDelete.name) {
                 vm.conditionList.splice(i, 1);
                 }
                 } */
            });
        }

        function save(condition) {
            var fd = new FormData();
            fd.append('file', condition.attachment);
            fd.append('name', condition.name);

            $http
                .post(URL, fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                })
                .success(function () {
                    vm.savingFailed = false;
                    fetchConditions();
                    $rootScope.$broadcast(
                        vm.addConditionSuccessEvent,
                        condition.name
                    );
                })
                .error(function (error) {
                    vm.savingFailed = true;
                    vm.errorMessage = error.message;
                });
        }

        async function download(id) {
            const downloadUrl = URL + '/' + id;
            reactShell.downloadFile(downloadUrl);
        }

        vm.order = function (predicate) {
            vm.reverse = vm.predicate === predicate ? !vm.reverse : false;
            vm.predicate = predicate;
        };
    }
})();
